<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header" class="d-flex">
          <strong class="mdrive-header-text">Market Specific Settings</strong>
        </div>
        <b-row>
          <b-col md="3" class="my-0">

            <div style="height: 68vh; overflow: auto">
              <b-list-group>
                <b-list-group-item :id="r.code" v-for="r in regions" button class="d-flex justify-content-between align-items-center" @click="selectRegion(r)" style="padding: 5px 5px 5px 20px;">
                  {{ r.name }}
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-col>
          <b-col md="6">
            <div v-if="activeTaxRegion">
              <b-row style="vertical-align: middle;padding-bottom:5px;">
                <b-col md="6" class="d-inline-flex">
                  <h4>{{ activeTaxRegion.name }}</h4>

                </b-col>

              </b-row>
              <b-row>
                <div v-if="noConfig" class="alert alert-warning fade show" role="alert">
                  <div aria-live="polite"><strong>No market fee properties set yet.</strong></div>
                </div>
              </b-row>


              <table aria-busy="false" class="table b-table table-sm border-bottom">
                <tbody>
                  <tr v-for="(mp, mi) in activeTaxRegion.marketFeeProperties">
                    <td>
                      <b-row>
                        <b-col md="5"><strong>{{ mp.description }} </strong></b-col>
                        <b-col v-if="mp.__type === 'array'" md="7">
                          <table aria-busy="false" class="table b-table table-sm border-bottom mb-0">
                            <tbody>
                              <tr v-for="mpp in mp.value">
                                <td>
                                  <b-row>
                                    <b-col md="8">{{ mpp.description }}</b-col>
                                    <b-col md="4">
                                      <b-col v-if="mpp.__type === 'decimal'" md="14">
                                        <b-form-input size="sm" type="text" v-model="mpp.value" @change="nullOnEmpty(mpp)"
                                                      :id="mpp.name+mp.name" v-bind:class="{'is-invalid': validateErrors.has(mpp.name+mp.name) }"
                                                      v-validate="{decimal, min_value:0}"></b-form-input>
                                        <em class="error invalid-feedback">{{ validateErrors.first('}}{{mpp.name}}{{mp.name}}{{') }}</em>
                                      </b-col>
                                      <b-col v-else-if="mpp.__type === 'boolean'" md="5">
                                        <c-switch :id="mpp.name+mp.name" size="sm" v-model="mpp.value" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </b-col>
                                      <b-col v-else md="14">
                                        <b-form-input :id="mpp.name+mp.name" size="sm" type="text" v-model="mpp.value"></b-form-input>
                                      </b-col>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                        <b-col v-else-if="mp.__type === 'decimal'" md="2">
                          <template v-if="mp.name === 'DMVFeeAdjustment'">
                            <b-form-input size="sm" type="text" v-model="mp.value" @change="nullOnEmpty(mp)"
                                          :id="mp.name" v-bind:class="{'is-invalid': validateErrors.has(mp.name) }"
                                          v-validate="{decimal}"></b-form-input>
                            <em class="error invalid-feedback">{{ validateErrors.first('}}{{mp.name}}{{') }}</em>
                          </template>
                          <template v-else>
                            <b-form-input size="sm" type="text" v-model="mp.value" @change="nullOnEmpty(mp)"
                                          :id="mp.name" v-bind:class="{'is-invalid': validateErrors.has(mp.name) }"
                                          v-validate="{decimal, min_value:0}"></b-form-input>
                            <em class="error invalid-feedback">{{ validateErrors.first('}}{{mp.name}}{{') }}</em>
                          </template>
                        </b-col>
                        <b-col v-else-if="mp.__type === 'boolean'" md="2">
                          <c-switch :id="mp.name" size="sm" v-model="mp.value" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </b-col>
                        <b-col v-else md="3">
                          <b-form-input :id="mp.name" size="sm" type="text" v-model="mp.value"></b-form-input>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="ml-auto">
                <button id="btnSave" class="btn btn-info ml-3" @click="saveSalesTax"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
              </div>
            </div>
            <div v-else>
              <table class="table b-table table-striped table-hover table-bordered table-sm">
                <tbody class="">
                  <tr class="b-table-empty-row"><td><div role="alert" aria-live="polite"><div class="text-center my-2">Select a state to review market settings.</div></div></td></tr>
                </tbody>
              </table>
            </div>
          </b-col>
          <b-col md="3" style="float:right">
            <b-card no-body style="max-width:25em;">
              <div slot="header" v-b-toggle.searchFromZip>
                <strong>Tax Rate Lookup</strong>
                <div class="card-actions">
                  <b-btn id="btnZipLookup" class="btn btn-minimize"><i class="icon-arrow-up"></i></b-btn>
                </div>
              </div>
              <b-collapse id="searchFromZip" visible>
                <b-card-body>
                  <b-row>
                    <b-col md="8" class="my-0">
                      <b-form-input id="inpZipCode" class="my-0" size="sm" type="text" v-model="searchZip" placeholder="Search by Zip"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-col md="1" class="my-0">
                    <b-btn id="btnSearch" size="sm" @click="submitZipSearch()">Search</b-btn>
                  </b-col>
                  <slot v-if="searchedRegions">
                    <b-row>
                      <b-col md="9" class="mt-3 mb-2">
                        Override City, County Tax Rates:
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12" class="my-0">
                        <b-input-group>
                          <b-form-select id="sltCityCounty" size="sm" v-model="selectedTaxRegion">
                            <option v-for="s in searchedRegions" :value="s">{{s.RegionName}}</option>
                          </b-form-select>
                        </b-input-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12" class="my-0">
                        <b-input-group-append>
                          <b-btn id="btnPreview" size="sm" @click="submitImportStateFees()">Override</b-btn>
                        </b-input-group-append>
                      </b-col>
                    </b-row>
                  </slot>
                </b-card-body>
              </b-collapse>
            </b-card>
          </b-col>
        </b-row>

      </b-card>
</div>

    <loading :show="boolLoading"
              :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'
import { isNullOrUndefined } from 'util'
import {Validator} from 'vee-validate'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    axios.get('/api/statetax/getregions')
      .then(response => {
        this.boolLoading = false
        this.regions = response.data.regions
       
        if (isNullOrUndefined(response.data.selectedRegion)) {
          if (!isNullOrUndefined(response.data.defaultZip)) {
            this.searchZip = response.data.defaultZip
            this.submitZipSearch()
          }
          this.showDismissibleAlert = true
          this.errMsg = 'There is no market configured for your dealership. Please configure one below.'
          this.showDismissibleAlert = true
          this.dismissibleType = 'warning'
        } else {
          this.activeTaxRegion = {}
          this.activeTaxRegion.name = response.data.selectedRegion
          this.activeTaxRegion.code = response.data.regions.find(x => x.name == response.data.selectedRegion).code
          this.activeTaxRegion.id = response.data.regions.find(x=> x.name==response.data.selectedRegion).id
          this.activeTaxRegion.marketFeeProperties = response.data.selectedRegionData[0].value
          this.noConfig = response.data.selectedRegionData[1].value
        }
      })
      .catch(error => {
        if (error.response.status == 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      showZipImport: false,
      activeTaxRegion: null,
      selectedTaxRegion: null,
      searchZip: null,
      regions: [],
      searchedRegions: null,
      noConfig: false
    }
  },
  methods: {
    selectRegion(r, clearSubRegions = true) {
      if (clearSubRegions) {
          this.searchedRegions = null
      }
      this.showDismissibleAlert = false
      this.activeTaxRegion = r
      this.activeTaxRegion.marketFeeProperties = []
      var obj = {}
      obj.market = r.code
      this.boolLoading = true
      axios.post('/api/statetax/getmarketfeetax', obj)
        .then(response => {
          this.boolLoading = false
          this.activeTaxRegion.marketFeeProperties = response.data.marketFeeProperties
          this.noConfig = response.data.noConfig
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
    },
    submitZipSearch() {
      if (this.searchZip) {
        let obj = {}
        obj.incity = true
        obj.zip = this.searchZip
        this.boolLoading = true
        axios.post('/api/statetax/gettaxregions', obj)
        .then(response => {
          this.boolLoading = false
          this.searchedRegions = response.data
          var x = 1
          this.searchedRegions.forEach(i => {
            i.id = x
            x++
          })
          this.selectedTaxRegion = response.data[0]
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        })
        .then(() => {
          let obj = {zip: this.searchZip}
          axios.post('/api/statetax/getmarketfromzip', obj)
            .then(response => {
              console.log(this.activeTaxRegion)
              if (this.activeTaxRegion == null || this.activeTaxRegion.id != response.data.market) {
                //switch the region
                this.selectRegion(this.regions.find(r => r.id == response.data.market), false)
                  .then(() => { })

              }
            })
            .catch(error => {
              if (error.response.status == 403) { this.$router.push('/login') }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
              this.dismissibleType = 'danger'
            })
         })
      }
    },
    copyPctVals(oldTaxObj, newTaxObj) {
      oldTaxObj.forEach(prop => {
        let propName = prop.name
        if (propName != "Lease" && propName != "Retail") {
          if (propName.includes("Pct")) {
            let tmp = newTaxObj.filter(p => p.name == propName)
            prop.value = tmp.length == 0 ? 0 : tmp[0].value
          }
        }
        if (propName == "Lease" || propName == "Retail") {
          let tmp = newTaxObj.filter(p => p.name == propName)
          let nestedProp = tmp.length == 0 ? [] : tmp[0].value
          this.copyPctVals(prop.value, nestedProp)
        }
      })
    },
    submitImportStateFees() {
      if (this.selectedTaxRegion) {
        let obj = {}
        if (this.selectedTaxRegion.InCity != null) { obj.incity = this.selectedTaxRegion.InCity }
        obj.regionid = this.selectedTaxRegion.RegionID
        obj.zip = this.searchZip
        obj.subregionid = this.selectedTaxRegion.SubregionID
        this.boolLoading = true
        axios.post('/api/statetax/getzipregionfeetax', obj)
          .then(response => {
            this.boolLoading = false
           /* this.activeTaxRegion = this.regions.filter(item => {
              return item.code.indexOf(response.data.selectedRegion) > -1
            })[0]*/
            //this.activeTaxRegion.marketFeeProperties = response.data.marketFeeProperties
            this.copyPctVals(this.activeTaxRegion.marketFeeProperties, response.data.marketFeeProperties)
            this.noConfig = response.data.noConfig
          })
          .catch(error => {
            if (error.response.status == 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
            this.dismissibleType = 'danger'
          }).then(() => {
              this.saveSalesTax()
          })
      }
    },
    saveSalesTax () {
      if (!this.activeTaxRegion) {
        this.errMsg = 'Unknown error.'
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
        return
      }
      if (this.activeTaxRegion.name == null) {
        this.errMsg = 'Please select a tax region to configure taxes and fees.'
        this.showDismissibleAlert = true
        this.dismissibleType = 'danger'
        return
      }

      this.boolLoading = true
      let obj = {}
      obj.market = this.activeTaxRegion.code

      var marketdata = this.activeTaxRegion.marketFeeProperties.filter(item => item.__type != 'array')
      this.activeTaxRegion.marketFeeProperties.filter(item => item.__type == 'array').forEach(function (item) {
        item.value.forEach(function (i) {
          marketdata.push(i)
        })
      })

      obj.data = marketdata
      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post('/api/statetax/savemarketfeetax', obj)
            .then(response => {
              this.errMsg = 'Tax Changes Saved for ' + obj.market
              this.dismissibleType = 'success'
              this.showDismissibleAlert = true
              this.boolLoading = false
              this.noConfig = false
              
              this.$emit('clicked', 'true')
            })
            .catch(error => {
              if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

              console.log(error)
              this.boolLoading = false
              this.errMsg = 'There was an error saving data : ' + error
              this.showDismissibleAlert = true
              this.dismissibleType = 'danger'
              if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
            })
        } else {
          this.boolLoading = false
          this.errMsg = 'Please fix validation errors'
          this.showDismissibleAlert = true
          this.dismissibleType = 'danger'
        }
      })
    },
    nullOnEmpty (o) {
      if (o.value === '') { o.value = 0 }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style scoped>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* Card Header */

  .card-header {
    padding: 1.25rem calc(1.25rem + 15px) !important;
  }

  .mdrive-header-text {
    line-height: 35px;
  }

  #btnSave {
    /* border-radius: .25rem !important; */
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/MarketSpecificSettings.vue